// https://greensock.com/docs/v3/Installation
import { gsap } from 'gsap'
import utils from './utils';

const POINTER = '#tip-pointer'

const onMouseMove = function(e) {
  /*
  gsap.to(POINTER, 0.3, {
    css: {left: e.pageX, top: e.pageY}
  });
  */
  gsap.set(POINTER, {
    css: {left: e.pageX, top: e.pageY}
  })
}

const dataTipOut = function(e) {
  window.app.$body.css({cursor: ''})
  gsap.killTweensOf(POINTER)
  gsap.to(POINTER, 0.3, {scale:0.1, autoAlpha:0 })
}

const dataTipIn = function(e) {
  let $tipContent = $(this).find('[data-tip]')
  let tipStr = ''
  if($tipContent.length){
    tipStr = $tipContent.html() //.clone()
  } else if ($(this).attr('data-tip-in-src')) {
    tipStr = '<img src="' + $(this).attr('data-tip-in-src') + '" />'
  } else {
    tipStr = $(this).attr('data-tip-in')
  }
  if(tipStr){
    window.app.$body.css({cursor: 'none'})
    $(POINTER).html(tipStr)
    gsap.killTweensOf(POINTER)
    gsap.to(POINTER, 0.3, {scale:1, autoAlpha:1 })
  } else {
    dataTipOut(e)
  }
}

const appInit = function() {
  if(window.app.isTouch()){

  } else {

    window.app.$body.append('<div id="tip-pointer-wrapper"><div id="tip-pointer"></div></div>')

    $(document).on('mousemove', onMouseMove)
    $(document).on('mouseenter', '[data-tip-in]', dataTipIn) //mouseover
    $(document).on('mouseleave', '[data-tip-out]', dataTipOut) //mouseOut

    $(window).on('app:page_init', dataTipOut)
  }
}

const appDestroy = function() {
  if(window.app.isTouch()){

  } else {
    $(document).off('mousemove', onMouseMove)
    $(document).off('mouseenter', '[data-tip-in]', dataTipIn) //mouseover
    $(document).off('mouseleave', '[data-tip-out]', dataTipOut) //mouseOut

    $(window).off('app:page_init', dataTipOut)
  }
}

export default {appInit, appDestroy}
